import { jsx } from "react/jsx-runtime";
import {
  unsafe__withoutCapture,
  useEditor,
  useValue
} from "@tldraw/editor";
import { createContext, useCallback, useContext } from "react";
import { useUiEvents } from "../../context/events.mjs";
const StylePanelContext = createContext(null);
function StylePanelContextProvider({ children, styles }) {
  const editor = useEditor();
  const trackEvent = useUiEvents();
  const onHistoryMark = useCallback((id) => editor.markHistoryStoppingPoint(id), [editor]);
  const enhancedA11yMode = useValue("enhancedA11yMode", () => editor.user.getEnhancedA11yMode(), [
    editor
  ]);
  const onValueChange = useCallback(
    function(style, value) {
      const skipNextShapeStyle = unsafe__withoutCapture(
        () => editor.getSelectedShapeIds().length > 0 && editor.inputs.getAccelKey()
      );
      editor.run(() => {
        if (editor.isIn("select")) {
          editor.setStyleForSelectedShapes(style, value);
        }
        if (!skipNextShapeStyle) {
          editor.setStyleForNextShapes(style, value);
        }
        editor.updateInstanceState({ isChangingStyle: true });
      });
      trackEvent("set-style", { source: "style-panel", id: style.id, value });
    },
    [editor, trackEvent]
  );
  const onOpacityChange = useCallback(
    function(opacity) {
      const skipNextShapeStyle = unsafe__withoutCapture(
        () => editor.getSelectedShapeIds().length > 0 && editor.inputs.getAccelKey()
      );
      editor.run(() => {
        if (editor.isIn("select")) {
          editor.setOpacityForSelectedShapes(opacity);
        }
        if (!skipNextShapeStyle) {
          editor.setOpacityForNextShapes(opacity);
        }
        editor.updateInstanceState({ isChangingStyle: true });
      });
      trackEvent("set-style", { source: "style-panel", id: "opacity", value: opacity });
    },
    [editor, trackEvent]
  );
  return /* @__PURE__ */ jsx(
    StylePanelContext.Provider,
    {
      value: {
        styles,
        enhancedA11yMode,
        onHistoryMark,
        onValueChange,
        onOpacityChange
      },
      children
    }
  );
}
function useStylePanelContext() {
  const context = useContext(StylePanelContext);
  if (!context) {
    throw new Error("useStylePanelContext must be used within a StylePanelContextProvider");
  }
  return context;
}
export {
  StylePanelContextProvider,
  useStylePanelContext
};
//# sourceMappingURL=StylePanelContext.mjs.map
